/**
 * Zentrale PWA-Konstanten (NT-PUSH-PWA-01).
 *
 * Quelle der Wahrheit für Werte, die auch in `public/manifest.json` und `public/sw.js`
 * auftauchen. Beide Dateien liegen außerhalb der Vite/TS-Build-Pipeline (statisch aus
 * `public/` ausgeliefert, `sw.js` läuft unbundled im Service-Worker-Kontext) und können
 * diese Datei technisch nicht importieren — Werte dort manuell synchron halten (etabliertes
 * „kein Shared-Import für reine Anzeige-/Konfigurationswerte"-Pattern, siehe CLAUDE.md).
 * Bei jeder Änderung hier auch `manifest.json` + `sw.js` nachziehen.
 */

// Aus --bg-base (design-tokens.css) — Theme-/Background-Farbe für Manifest + <meta theme-color>.
export const PWA_THEME_COLOR = '#0a0a0f';
export const PWA_BACKGROUND_COLOR = '#0a0a0f';

export const PWA_APP_NAME = 'Nighttrade';
// Muss <=12 Zeichen sein (Homescreen-Label-Konvention) — "Nighttrade" hat 10.
export const PWA_SHORT_NAME = 'Nighttrade';

/**
 * Service-Worker-Cache-Versions-Präfix. Bei jeder strukturellen SW-Änderung (Precache-Liste,
 * Caching-Strategie) den Zähler in `public/sw.js`s `CACHE`-Konstante erhöhen, damit
 * `activate` alte Caches zuverlässig invalidiert. Diese Konstante hier ist nur die
 * dokumentierte Referenz (sw.js kann sie nicht importieren) — sw.js führt den echten Wert.
 */
export const SW_VERSION = 'nighttrade-v5';
